/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { SavedSearchDto } from '../models/saved-search-dto';

@Injectable({
  providedIn: 'root',
})
export class SavedSearchService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getSavedSearches
   */
  static readonly GetSavedSearchesPath = '/filters';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSavedSearches()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSavedSearches$Response(params?: {
  }): Observable<StrictHttpResponse<Array<SavedSearchDto>>> {

    const rb = new RequestBuilder(this.rootUrl, SavedSearchService.GetSavedSearchesPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<SavedSearchDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getSavedSearches$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSavedSearches(params?: {
  }): Observable<Array<SavedSearchDto>> {

    return this.getSavedSearches$Response(params).pipe(
      map((r: StrictHttpResponse<Array<SavedSearchDto>>) => r.body as Array<SavedSearchDto>)
    );
  }

  /**
   * Path part for operation createSavedSearch
   */
  static readonly CreateSavedSearchPath = '/filters';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createSavedSearch()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createSavedSearch$Response(params?: {
    body?: SavedSearchDto
  }): Observable<StrictHttpResponse<SavedSearchDto>> {

    const rb = new RequestBuilder(this.rootUrl, SavedSearchService.CreateSavedSearchPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SavedSearchDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createSavedSearch$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createSavedSearch(params?: {
    body?: SavedSearchDto
  }): Observable<SavedSearchDto> {

    return this.createSavedSearch$Response(params).pipe(
      map((r: StrictHttpResponse<SavedSearchDto>) => r.body as SavedSearchDto)
    );
  }

  /**
   * Path part for operation getSavedSearch
   */
  static readonly GetSavedSearchPath = '/filters/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSavedSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSavedSearch$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<SavedSearchDto>> {

    const rb = new RequestBuilder(this.rootUrl, SavedSearchService.GetSavedSearchPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SavedSearchDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getSavedSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSavedSearch(params: {
    id: string;
  }): Observable<SavedSearchDto> {

    return this.getSavedSearch$Response(params).pipe(
      map((r: StrictHttpResponse<SavedSearchDto>) => r.body as SavedSearchDto)
    );
  }

  /**
   * Path part for operation updateSavedSearch
   */
  static readonly UpdateSavedSearchPath = '/filters/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateSavedSearch()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSavedSearch$Response(params: {
    id: string;
    body?: SavedSearchDto
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, SavedSearchService.UpdateSavedSearchPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateSavedSearch$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSavedSearch(params: {
    id: string;
    body?: SavedSearchDto
  }): Observable<void> {

    return this.updateSavedSearch$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation deleteSavedSearch
   */
  static readonly DeleteSavedSearchPath = '/filters/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteSavedSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSavedSearch$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, SavedSearchService.DeleteSavedSearchPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteSavedSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSavedSearch(params: {
    id: string;
  }): Observable<void> {

    return this.deleteSavedSearch$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
